/* eslint-disable react/prop-types */
import { GetRequest } from "@/lib/http";
import { History } from "lucide-react";
import React, { useEffect, useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import {
  ikjNepaLogo,
  phNepaLogo,
  ibNepaLogo,
  egNepaLogo,
  nepaLogo,
  darkIkjNepaLogo,
} from "@/assets/";
import { useTheme } from "@/hooks/useTheme";
import { useMediaQuery } from "react-responsive";
import { cn } from "@/lib/utils";
import { FaUsersSlash } from "react-icons/fa6";

const ElectricityBeneficiaries = ({ setValue, metadata }) => {
  const [beneficiariesData, setBeneficiariesData] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);

  const isMobile = useMediaQuery({ query: "(max-width: 380px)" });

  const fetchBeneficiary = async () => {
    const { data, err } = await GetRequest({
      url: "/api/beneficiary?type=meter",
      setState: setLoading,
      errorMessage: "Error fetching beneficiaries",
    });

    if (!err) {
      const meterBeneficiaries = data.filter((item) => item.type === "meter");
      setBeneficiariesData(meterBeneficiaries);
    } else {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchBeneficiary();
  }, []);

  const images = {
    port: phNepaLogo,
    ikeja: useTheme().theme === "dark" ? darkIkjNepaLogo : ikjNepaLogo,
    enugu: egNepaLogo,
    ibadan: ibNepaLogo,
    eko: nepaLogo,
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="bg-primary cursor-pointer rounded-sm p-1 text-xs font-semibold text-white"
        role="button"
        type="button"
      >
        Beneficiaries
      </button>
      <Sheet open={isOpen} onOpenChange={() => setOpen(false)}>
        <SheetContent>
          <SheetHeader>
            <SheetTitle>Select Beneficiary</SheetTitle>
            <SheetDescription>
              Choose a beneficiary to purchase electricity for
            </SheetDescription>
          </SheetHeader>

          <div className="-mt-4">
            {loading ? (
              <div className="dark:border-darkBorder dark:bg-darkBg flex flex-col items-center justify-center gap-2 rounded-xl border bg-gray-50 py-7">
                <div className="bg-primary flex size-16 items-center justify-center rounded-full">
                  <History size={30} className="animate-spin text-white" />
                </div>
              </div>
            ) : beneficiariesData.length > 0 ? (
              <div
                className={cn(
                  "no-scrollbar mx-3 grid gap-2.5 overflow-y-auto md:grid-cols-3",
                  isMobile ? "grid-cols-2" : "grid-cols-2",
                )}
              >
                {beneficiariesData
                  .sort(
                    (a, b) => new Date(b.updated_at) - new Date(a.updated_at),
                  )
                  .map((item, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        const discoIndex = metadata.discos.findIndex(
                          (value) =>
                            value &&
                            value
                              .toLowerCase()
                              .includes(item.disco?.toLowerCase()),
                        );
                        setValue("disco", discoIndex);
                        setValue("type", item.meter_type);
                        setValue("number", item.value);
                        setValue("savebeneficiary", false);
                        setOpen(false);
                      }}
                      className="group hover:border-primary hover:dark:border-primary col-span-1 flex cursor-pointer flex-col items-center gap-2 rounded-xl border p-3 transition-colors duration-200 ease-in-out hover:border-2 dark:border-gray-500"
                    >
                      <img
                        src={images[item.disco?.toLowerCase()]}
                        alt={item.disco}
                        className="size-10 object-cover"
                      />
                      <h3 className="text-center text-xs font-medium transition-colors duration-200 ease-in-out group-hover:text-black group-hover:dark:text-white">
                        {item?.name}
                      </h3>

                      <p className="text-xs text-gray-500 dark:text-gray-300">
                        {item?.value}
                      </p>
                    </div>
                  ))}
              </div>
            ) : (
              <div className="dark:border-darkBorder dark:bg-darkBg mx-4 flex flex-col items-center justify-center gap-3 rounded-xl border bg-gray-50 py-4">
                <div className="bg-primary flex size-14 items-center justify-center rounded-full">
                  <FaUsersSlash size={27} className="text-white" />
                </div>
                <p className="text-center font-medium text-gray-500 dark:text-gray-200">
                  No beneficiaries found
                </p>
              </div>
            )}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default ElectricityBeneficiaries;
